// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__Gew18","sticky":"Header_sticky__45AQD","right":"Header_right__aQqPZ"};